export enum Cookie {
  SELECTED_REGION = "selectedRegion",
}
